import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactElement } from 'react';
import { RouterProvider } from 'react-router-dom';

import '../lib/i18n.js'; // side-effect: initialize i18next + react-i18next
import { AuthProvider } from '../lib/auth.js';
import { LocationProvider } from '../lib/locations.js';
import { queryClient } from '../lib/queryClient.js';

import { router } from './router.js';
import { ThemeProvider } from './ThemeProvider.js';

/** Admin-web root: QueryClient > Theme > Auth > Location > Router (PL-03). */
export function App(): ReactElement {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <LocationProvider>
            <RouterProvider router={router} />
          </LocationProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
